"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.array.map.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _AccessibleInputLabel = _interopRequireDefault(require("./AccessibleInputLabel"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../constants");
var _lodash = _interopRequireDefault(require("lodash"));
var _clsx = _interopRequireDefault(require("clsx"));
var _ui = require("@evidation/ui");
var _excluded = ["required", "label", "labelStyle", "inputStyle", "initialValue", "style", "name", "options", "error", "omitPlaceholder", "convertValuesToStrings", "placeholderValue", "value", "defaultValue", "labelTooltip", "onChange", "onBlur", "position"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Select = _styledComponents["default"].select.withConfig({
  displayName: "SelectInput__Select"
})(["", " ", ";"], function (props) {
  // evidation UI styles dont need any defaults
  if (props.inputStyle === 'ehp') {
    return (0, _styledComponents.css)(["", " margin-bottom:8px;"], _ui.InputStyles);
  } else {
    return (0, _styledComponents.css)(["width:100%;padding:16px;margin-bottom:8px;border-radius:3px;border:1px solid rgba(0,0,0,0.25);font-size:1rem;-webkit-appearance:none;box-sizing:border-box;box-shadow:none;&:disabled{background-color:#e6e6e6;}:focus{outline:none !important;}&:focus{box-shadow:0 0 2px 2px #6192ff;}"]);
  }
}, function (props) {
  if (props.inputStyle === "dark") {
    return (0, _styledComponents.css)(["color:#0c4e69;background-color:#062633;&:disabled{background-color:#031117;}"]);
  } else if (props.inputStyle === "darker") {
    return (0, _styledComponents.css)(["color:#0c4e69;background-color:#061e26;&:disabled{background-color:#000000;}"]);
  } else if (props.inputStyle === "light") {
    return (0, _styledComponents.css)(["color:#111;background-color:#fff;&:disabled{background-color:#e6e6e6;}"]);
  } else if (props.inputStyle === "muted") {
    return (0, _styledComponents.css)(["color:#666666;background-color:#f7f7f7;border:1px solid #e0e0e0;&:disabled{background-color:#e6e6e6;}"]);
  } else if (props.inputStyle === "achievement") {
    return (0, _styledComponents.css)(["fontSize:16px background-color:#FCFCFC;border:1px solid #E6E6E6;color:#000;padding:20px;&:disabled{background-color:#e6e6e6;}"]);
  }
});
var SelectInput = function SelectInput(_ref) {
  var required = _ref.required,
    label = _ref.label,
    _ref$labelStyle = _ref.labelStyle,
    labelStyle = _ref$labelStyle === void 0 ? 'dark' : _ref$labelStyle,
    _ref$inputStyle = _ref.inputStyle,
    inputStyle = _ref$inputStyle === void 0 ? 'achievement' : _ref$inputStyle,
    _ref$initialValue = _ref.initialValue,
    initialValue = _ref$initialValue === void 0 ? 'Select one from the list' : _ref$initialValue,
    style = _ref.style,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'select_dropdown' : _ref$name,
    options = _ref.options,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? '' : _ref$error,
    _ref$omitPlaceholder = _ref.omitPlaceholder,
    omitPlaceholder = _ref$omitPlaceholder === void 0 ? false : _ref$omitPlaceholder,
    _ref$convertValuesToS = _ref.convertValuesToStrings,
    convertValuesToStrings = _ref$convertValuesToS === void 0 ? true : _ref$convertValuesToS,
    placeholderValue = _ref.placeholderValue,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    labelTooltip = _ref.labelTooltip,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return false;
    } : _ref$onChange,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    position = _ref.position,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _react.useEffect)(function () {
    // HACK ALERT!
    //   If the field is required and we have a default but no real value,
    //   trigger a change event with the default value to store it in
    //   Redux. This is necessary for values that are required by the
    //   backend.
    if (required && defaultValue && value === '') {
      onChange(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var allOptions = options;
  if (!omitPlaceholder) {
    var realPlaceholderValue;
    if (placeholderValue === undefined) {
      realPlaceholderValue = initialValue || '';
    } else {
      realPlaceholderValue = placeholderValue;
    }
    allOptions = [{
      label: initialValue,
      value: realPlaceholderValue,
      isPlaceholder: true
    }].concat((0, _toConsumableArray2["default"])(allOptions));
  }
  var getRealOptionValue = function getRealOptionValue(option) {
    var realValue;
    if (option.value !== undefined) {
      realValue = option.value;
    } else if (option.isPlaceholder) {
      realValue = option.label;
    } else {
      realValue = _lodash["default"].snakeCase(option.label);
    }
    if (convertValuesToStrings) {
      return String(realValue);
    }
    return realValue;
  };

  // Calculate the selected index based on the passed in value and use that as
  //   the `value` prop passed to the <select> element. This way, we can do our
  //   own handling of `value` but still keep selection state consistent.
  var realValue = defaultValue && ['', undefined].includes(value) ? defaultValue : value;
  var selectedIndex = allOptions.findIndex(function (option) {
    return !option.disabled && getRealOptionValue(option) === realValue;
  });
  if (selectedIndex === -1) {
    selectedIndex = undefined;
  }

  /**
   * Takes an event and returns the "real" currently selected value,
   *   accounting for non-string values that are not supported natively by the
   *   <select> element as well as any transformations that need to be applied.
   * @param {import('react').SyntheticEvent<HTMLSelectElement>} event
   */
  var realValueFromEvent = function realValueFromEvent(event) {
    if (event.isSimulatedByTest) {
      // This is only here to support tests where we simulate 'change' events
      //   manually, especially using Enzyme. Ideally, we would remove all of
      //   these in favor of using Testing Library and its user-event helper,
      //   which better simulates true user behavior.
      var _selectedOption = allOptions.find(function (option) {
        return option.value === event.target.value;
      });
      return getRealOptionValue(_selectedOption);
    }
    var optionIndex = parseInt(event.target.value, 10);
    var selectedOption = allOptions[optionIndex];
    return getRealOptionValue(selectedOption);
  };

  // Override the relevant events so that we can call them with non-string
  //   values.
  var handleChange = function handleChange(event) {
    var realValue = realValueFromEvent(event);
    onChange(realValue);
  };
  var handleBlur = function handleBlur(event) {
    var realValue = realValueFromEvent(event);
    onBlur(realValue);
  };
  var isInline = position === 'inline' || position === 'inline-label-after';
  return /*#__PURE__*/_react["default"].createElement(_ui.Flex, {
    items: isInline ? 'center' : 'flex-start',
    direction: isInline ? 'row' : 'column',
    fullWidth: true,
    spaceX: isInline ? 4 : undefined
  }, position !== 'inline-label-after' && /*#__PURE__*/_react["default"].createElement(_AccessibleInputLabel["default"], {
    required: required,
    label: label,
    labelStyle: labelStyle,
    labelFor: name,
    labelTooltip: labelTooltip
  }), /*#__PURE__*/_react["default"].createElement(Select, (0, _extends2["default"])({
    "aria-required": required,
    required: required,
    value: selectedIndex,
    name: name,
    onChange: handleChange,
    onBlur: handleBlur,
    style: style,
    inputStyle: inputStyle
  }, rest, {
    className: (0, _clsx["default"])(error && 'evi-error--border')
  }), allOptions.map(function (item, index) {
    return (
      /*#__PURE__*/
      // Note: Since we override the values passed to the event handlers,
      //   the `value` attribute here is only used to maintain the currently
      //   selected option by index.
      _react["default"].createElement("option", {
        key: index,
        value: index,
        disabled: item.disabled
      }, item.label)
    );
  })), position === 'inline-label-after' && /*#__PURE__*/_react["default"].createElement(_AccessibleInputLabel["default"], {
    required: required,
    label: label,
    labelStyle: labelStyle,
    labelFor: name,
    labelTooltip: labelTooltip
  }));
};
SelectInput.propTypes = {
  name: _propTypes["default"].string,
  label: _propTypes["default"].string,
  labelStyle: _propTypes["default"].oneOf(_constants.TextLabelStyles),
  inputStyle: _propTypes["default"].oneOf(["dark", "light", "darker", "muted", "achievement"]),
  onChange: _propTypes["default"].func,
  options: _propTypes["default"].array.isRequired,
  initialValue: _propTypes["default"].string,
  position: _propTypes["default"].oneOf(['inline', 'normal', 'inline-label-after']),
  style: _propTypes["default"].object,
  error: _propTypes["default"].string
};
var _default = exports["default"] = SelectInput;